// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rXXnj","inner":"Footer_inner__tzWhS"};